module.exports = __webpack_public_path__ + "img/tempo_2.ba1db883.png";